import Cookies from 'universal-cookie';

const cookies = new Cookies();
const MAXIMUM_VARNISH_BUCKET_NUMBER = 99;

const shouldRedirectToMyPage = (atRatio) => {
    const clientBucket = parseInt(cookies.get('clientBucket') || MAXIMUM_VARNISH_BUCKET_NUMBER, 10);

    return clientBucket < parseFloat(atRatio) * 100;
};

export default shouldRedirectToMyPage;



/** WEBPACK FOOTER **
 ** ./src/utils/mypage-ab.js
 **/